// ДОПУСК НА ШАГ ПО АДРЕСУ — чистая функция (`s922.d2`, B10-1).
//
// Вход на `#s5` при пустом шаге 3 даёт экран без данных: `toWizardInput` бросает
// `wizard state is misaligned` (шаг 2 — N этапов, шаг 3 — 0 рядов). Случай возникает сам: ключ
// стёрт подъёмом версии конверта (`s893.d1`), чистка браузера, другое устройство. Решение — одна
// проверка готовности: данных для шага не хватает → шаг 1, конверт не трогать.
//
// ГОТОВНОСТЬ — ИЗ УЖЕ НАПИСАННЫХ ГЕЙТОВ, своих порогов здесь нет:
//   · шаги 3+ — гейт трёх шага 2 (`ctaGate` по сохранённым рядам, `stageGate.js`);
//   · шаги 4+ — ещё и гейт каждой карточки шага 3 (`gateOK`, `deckGate.js`), рядов ровно столько,
//     сколько этапов;
//   · шаги 4+ — у каждого этапа читаемая дата старта (или объявленный `openStart`), тем же разбором,
//     что у адаптера (`toDecimalYear`). Экраны 4–7 строят паспорт на рендере, и этап без даты там —
//     второй бросок `toWizardInput` (`rows carry no date`), после которого экран падения, а перезагрузка
//     того же конверта роняет снова — петля (qa блока 10, B10-4). Интерфейс такого ряда не пишет;
//     это правка конверта руками.
// Черновик шага 2 (`stageDraft`) в допуск не входит: он не данные, а незаконченный ввод, и
// выкидывать человека на шаг 1 за открытый ряд было бы строже, чем гейт самого шага 2.
//
// ⛔ НЕ БРОСАЕТ И НЕ ЗОВЁТ `toWizardInput`. Конверт только читается.
//
// ⭐ ГДЕ ЕЁ ЗОВУТ — НА ВСЕХ ТРЁХ ВХОДАХ (`s945.d3`, уточняет `s922.d2`): `goTo`, подписка роутера
// (`popstate`, ручная правка хеша) и подъём (позиция конверта до первой записи адреса) — всё в
// `WizardProvider.jsx`. Исключений для футера нет. Проводку сторожит `WizardShell.test.jsx`,
// блок «допуск по адресу — все три входа», по тесту на вход.

import { stepNumber } from './address.js';
import { ctaGate } from './steps/stageGate.js';
import { gateOK } from './steps/deckGate.js';
import { toDecimalYear } from './toWizardInput.js';

/** Куда отправляется отказ: первый шаг, без карточки и подэкрана. */
export const ADMISSION_FALLBACK = { step: 1, card: null, sub: null };

/**
 * Хватает ли в конверте данных для шага `step`.
 * @param {object} session конверт визарда
 * @param {number|string} step номер шага или адрес (`s5`, `#s3/2/b`)
 */
export function stepReady(session, step) {
  const n = typeof step === 'number' ? step : stepNumber(step);
  if (n <= 2) return true;
  const input = (session && session.input) || {};
  const stages = Array.isArray(input.stages) ? input.stages : [];
  if (ctaGate(stages, null) !== null) return false;
  if (n <= 3) return true;
  const sliders = Array.isArray(input.sliders) ? input.sliders : [];
  if (!stages.every((r) => (r && r.openStart) || toDecimalYear(r && r.start) !== null)) return false;
  return sliders.length === stages.length && sliders.every(gateOK);
}

/**
 * Разобранный адрес → он же, если данных хватает, иначе `ADMISSION_FALLBACK` (шаг 1).
 * @param {object} session конверт визарда
 * @param {{step: number, card: number|null, sub: string|null}} parsed
 */
export function admitAddress(session, parsed) {
  if (!parsed) return parsed;
  return stepReady(session, parsed.step) ? parsed : { ...ADMISSION_FALLBACK };
}
